import {Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {HttpClient, HttpEvent} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {ResourceArticle, ResourceHistory} from '../model/resource';

@Injectable({
  providedIn: 'root'
})
export class ResourcesService {

  protected resources: ResourceArticle[];
  protected resourcesSubject = new ReplaySubject<ResourceArticle[]>();

  constructor(private http: HttpClient) {
    this.http.get<ResourceArticle[]>(`${environment.backend}/resources`).subscribe(data => {
      this.resources = data;
      this.resourcesSubject.next(this.resources);
    });
  }

  listResources(): Observable<ResourceArticle[]> {
    return this.resourcesSubject.asObservable();
  }

  downloadAttachment(id: string): Observable<HttpEvent<Blob>> {
    return this.http.get(`${environment.backend}/resources/${id}`, {
      responseType: 'blob',
      observe: 'events',
      reportProgress: true
    });
  }

  downloadDocumentation(): Observable<HttpEvent<Blob>> {
    return this.http.get(`${environment.backend}/resources/doc`, {
      responseType: 'blob',
      observe: 'events',
      reportProgress: true
    });
  }

  history(): Observable<ResourceHistory[]> {
    return this.http.get<ResourceHistory[]>(`${environment.backend}/resources/history`);
  }
}
